module.exports = __webpack_public_path__ + "static/media/measure-tape.41ccd983.svg";